// SPDX-License-Identifier: AGPL-3.0-or-later

import VoiceConnectionManager from '@app/features/voice/engine/VoiceConnectionManager';
import VoiceStateManager from '@app/features/voice/engine/VoiceStateManager';
import LocalVoiceState from '@app/features/voice/state/LocalVoiceState';
export interface EffectiveAudioState {
	selfMute: boolean;
	selfDeaf: boolean;
	serverMute: boolean;
	serverDeaf: boolean;
	effectiveMute: boolean;
	effectiveDeaf: boolean;
}
interface ComputeEffectiveAudioStateParams {
	selfMute: boolean;
	selfDeaf: boolean;
	serverMute?: boolean;
	serverDeaf?: boolean;
}
interface EffectiveAudioStateOptions {
	connectionId?: string | null;
	selfMute?: boolean;
	selfDeaf?: boolean;
	serverMute?: boolean;
	serverDeaf?: boolean;
}
export function computeEffectiveAudioState(params: ComputeEffectiveAudioStateParams): EffectiveAudioState {
	const serverMute = params.serverMute ?? false;
	const serverDeaf = params.serverDeaf ?? false;
	return {
		selfMute: params.selfMute,
		selfDeaf: params.selfDeaf,
		serverMute,
		serverDeaf,
		effectiveMute: serverMute || serverDeaf || params.selfMute || params.selfDeaf,
		effectiveDeaf: serverDeaf || params.selfDeaf,
	};
}
export function getEffectiveAudioState(options?: EffectiveAudioStateOptions): EffectiveAudioState {
	const selfMute = options?.selfMute ?? LocalVoiceState.getSelfMute();
	const selfDeaf = options?.selfDeaf ?? LocalVoiceState.getSelfDeaf();
	const connectionId = options?.connectionId ?? VoiceConnectionManager.connectionId;
	const serverVoiceState = connectionId ? VoiceStateManager.getVoiceStateByConnectionId(connectionId) : null;
	return computeEffectiveAudioState({
		selfMute,
		selfDeaf,
		serverMute: options?.serverMute ?? serverVoiceState?.mute ?? false,
		serverDeaf: options?.serverDeaf ?? serverVoiceState?.deaf ?? false,
	});
}
